import { render, staticRenderFns } from "./summaryTable.vue?vue&type=template&id=709f79c7"
import script from "./summaryTable.vue?vue&type=script&lang=js"
export * from "./summaryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports